<template>
  <LoginPage :redirection-pathname="`/${locale}/auth/login`" />
</template>

<script lang="ts" setup>
import LoginPage from '@backmarket/nuxt-layer-oauth/LoginPage.vue'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

const locale = useI18nLocale()
</script>
